import { render, staticRenderFns } from "./JiShiCommissionAndClockDetail.vue?vue&type=template&id=01a70a45&scoped=true"
import script from "./JiShiCommissionAndClockDetail.vue?vue&type=script&lang=js"
export * from "./JiShiCommissionAndClockDetail.vue?vue&type=script&lang=js"
import style0 from "./JiShiCommissionAndClockDetail.vue?vue&type=style&index=0&id=01a70a45&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a70a45",
  null
  
)

export default component.exports